import { render, staticRenderFns } from "./ContentMenuGroup.vue?vue&type=template&id=5e412702&scoped=true"
import script from "./ContentMenuGroup.vue?vue&type=script&lang=js"
export * from "./ContentMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./ContentMenuGroup.vue?vue&type=style&index=0&id=5e412702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e412702",
  null
  
)

export default component.exports